import { render } from "./NonProductionMarker.vue?vue&type=template&id=65f80e48&scoped=true"
import script from "./NonProductionMarker.vue?vue&type=script&lang=js"
export * from "./NonProductionMarker.vue?vue&type=script&lang=js"

import "./NonProductionMarker.vue?vue&type=style&index=0&id=65f80e48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f80e48"]])

export default __exports__